import React from "react";
import { Box } from "@rebass/grid";
import slugifyString from "../../helpers/slugifyString";
import { useParams } from "react-router-dom";
import Container from "../Container/Container";
import Slider from "./Slider";
import CallToActionLink from "./CallToActionLink";
import formatPhone from "../../helpers/formatPhone";
import "./business-page.scss";
import WebsiteList from "./WebsiteList";
import MapEmbed from "../MapEmbed/MapEmbed";
import AddressLink from "../AddressLink/AddressLink";

const BizFull = ({ bizData, isFetching }) => {
  let { slug } = useParams();
  const business = bizData
    ? bizData.filter((biz) => slugifyString(biz.name) === slug)[0]
    : null;

  if (!business) {
    return <></>;
  }

  return (
    <>
      <Container className="business-header">
        <Box px={3} py={3} width={[1, 1, 2 / 3]} className="basic-info">
          <h1>{business.name}</h1>
          <p>{business.businessDescription}</p>
          <p className="address">
            <AddressLink {...business} />
          </p>
        </Box>
        <Box px={3} py={3} width={[1, 1, 1 / 3]} className="call-to-action">
          <CallToActionLink {...business} />
        </Box>
      </Container>

      <Slider images={business.images} />

      <Container className="business-details">
        <Box px={3} py={3} width={[1, 1 / 2, 3 / 4]} className="basic-info">
          <h2>Open for business</h2>
          <p>{business.currentSituationDescription}</p>
          <MapEmbed {...business} />
        </Box>
        <Box px={3} py={3} width={[1, 1 / 2, 1 / 4]}>
          <h3>Contact Us</h3>

          {business.operatingHours && (
            <div>
              <h4>Hours</h4>

              <p>
                {business.operatingHours.split("\n").map((item, key) => {
                  if (key === business.operatingHours.split("\n").length - 1) {
                    return <span key={key}>{item}</span>;
                  } else {
                    return (
                      <span key={key}>
                        {item}
                        <br />
                      </span>
                    );
                  }
                })}
              </p>
            </div>
          )}

          {business.websites && business.websites.length && (
            <WebsiteList {...business} />
          )}

          {business.phoneNumber && (
            <>
              <h4>Phone</h4>
              <p>
                {/* <a href={`tel:${business.phoneNumber}`}></a> */}
                {formatPhone(business.phoneNumber)}
              </p>
            </>
          )}
          {business.email && (
            <>
              <h4>Email</h4>
              <p>
                <a href={`mailto:${business.email}`}>{business.email}</a>
              </p>
            </>
          )}

          <CallToActionLink className="small" {...business} />
        </Box>
      </Container>
    </>
  );
};

export default BizFull;
